/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-09 18:10:21
 */ 
export const expertConsultationChatEn = {
    zxyjs:"Consultation closed",
    yjs:"finished",
    fanhui:"back",
    pingjia:"evaluation",
    fasong:"send",
    shengyuzxsj:"Remaining consultation time",
    tishi:"Glad to be of service? Please describe your problem."
}


// WEBPACK FOOTER //
// ./src/lang/home/expertConsultationChat/indexEn.js